// Import types
import { CalculationApi } from './calculation';
import { Address } from './generic';

export type ProjectOptions = {
    id: string;
    client: string;
    description: string;
    address: Address;
    created: Date;
    active: boolean;
    projectGroup: string;

    calculations?: CalculationApi[];
};

export class Project {
    public readonly id: string;
    public readonly client: string;
    public readonly description: string;
    public readonly address: Address;
    public readonly created: Date;
    public readonly active: boolean;
    public readonly projectGroup: string;

    public calculations?: CalculationApi[];

    constructor(options: ProjectOptions) {
        this.id = options.id;
        this.client = options.client;
        this.description = options.description;
        this.address = options.address;
        this.created = isNaN(options.created.valueOf()) ? new Date(1970, 0, 1) : options.created;
        this.active = options.active;
        this.projectGroup = options.projectGroup;

        this.calculations = options.calculations;
    }
}

// Afas project response types
export interface AfasProjectResponse {
    skip: number;
    take: number;
    rows?: AfasProject[];
}
export interface AfasProject {
    Projectnummer_: string;
    Omschrijving: string;
    Straat?: string;
    'Toev._voor_straat'?: null;
    Huisnummer?: number;
    'Toev._aan_huisnr.'?: string;
    Postcode?: string;
    Woonplaats?: string;
    Land?: string;
    Afgemeld: boolean;
    Naam?: string;
    Datum_toegevoegd: string;
    Begindatum: string;
    Opleverdatum_gepland?: null;
    Projectgroep: string;
    Administratie?: number;
    Projectleider?: string;
}

export function mapAfasProject(raw: AfasProject): Project {
    if (!raw) return null;

    return new Project({
        id: raw['Projectnummer_'],
        client: raw['Naam'],
        description: raw['Omschrijving'],
        address: {
            country: raw['Land'],
            city: raw['Woonplaats'],
            address: `${raw['Straat'] ?? ''}${raw['Toev._voor_straat'] ?? ''} ${raw['Huisnummer'] ?? ''}${raw['Toev._aan_huisnr.'] ?? ''}`.trim(),
            postalCode: raw['Postcode']
        },
        created: new Date(raw['Datum_toegevoegd']),
        active: !raw['Afgemeld'],
        projectGroup: raw['Projectgroep']
    });
}

export function mapMetaToProject(meta: CalculationApi): Project {
    if (!meta) return null;

    return new Project({
        id: meta.meta.projectId,
        client: meta.meta.client,
        description: meta.meta.description,
        address: {
            country: meta.meta.address?.country,
            city: meta.meta.address?.city,
            address: meta.meta.address?.address,
            postalCode: meta.meta.address?.postalCode
        },
        created: new Date(meta.meta.versionDate),
        active: true,
        projectGroup: '', // TODO: Unknown project group
        calculations: [meta]
    });
}
